var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{attrs:{"id":"video-player-popup","hideFooter":""},scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('p',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))]),(true)?_c('video-custom',{ref:"video-custom",attrs:{"src":_vm.src}}):_vm._e()]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }